// src/jira-software/site/types.ts
var JiraSoftwareSiteAriResourceOwner = "jira-software", JiraSoftwareSiteAriResourceType = "site";

export {
  JiraSoftwareSiteAriResourceOwner,
  JiraSoftwareSiteAriResourceType
};
